import React from 'react';

import SrBox from 'client/components/SrBox';
import SrFlex from 'client/components/SrFlex';

const SimpleCoverBadge = () => {
  return (
    <SrFlex align="center" columnGap="6px">
      <SrBox height="24px">
        <img
          src="/images/simplecover-light.png"
          alt="SimpleCover logo"
          style={{ height: '100%' }}
        />
      </SrBox>
    </SrFlex>
  );
};

SimpleCoverBadge.displayName = 'SimpleCoverBadge';

export default SimpleCoverBadge;
